import React from 'react';

export default function DashboardSkeleton() {
    return (
    <div className="flex flex-col items-center w-full max-w-[360px] animate-pulse ">

            <div className="relative">
                <div className="flex items-center justify-center w-32 h-32 rounded-full border-[3px] border-gray-400 p-[3px] shadow bg-gray-300">
                    <div className="w-14 h-14 bg-gray-300 rounded-full animate-pulse" />
                </div>

                <div className="flex items-center justify-center border border-gray-400 w-[29px] h-[29px] absolute bottom-1 right-2 bg-gray-300 text-white rounded-full animate-pulse"></div>
            </div>

            <span className="mt-4 text-gray-400 font-medium">۰ - - - - -</span>

            <div className="mt-8 w-full flex flex-col gap-4">
                <div className="w-full">
                    <div className="h-12 rounded-xl bg-gray-300 animate-pulse" />
                </div>

                <div className="w-full">
                    <div className="h-12 rounded-xl bg-gray-300 animate-pulse" />
                </div>

                <div className="w-full">
                    <div className="h-12 rounded-xl bg-gray-300 animate-pulse" />
                </div>

                <div className="w-full flex justify-center mt-6">
                    <div className="w-full bg-gray-300 rounded-xl h-12 animate-pulse" />
                </div>
            </div>

        </div>
    );
}
